import {put, takeEvery, call} from 'redux-saga/effects';
import {toast} from 'react-toastify';
import {
  createPriceAdjustmentApi,
  deletePriceAdjustmentApi,
  resetAllPriceAdjustmentsApi,
  getAllPriceAdjustmentsApi
} from 'helpers/services/api/platformPriceAdjustments';
import {
  CREATE_PRICE_ADJUSTMENT,
  CREATE_PRICE_ADJUSTMENT_SUCCESS,
  DELETE_PRICE_ADJUSTMENT,
  DELETE_PRICE_ADJUSTMENT_SUCCESS,
  RESET_ALL_PRICE_ADJUSTMENTS,
  RESET_ALL_PRICE_ADJUSTMENTS_SUCCESS,
  GET_ALL_PRICE_ADJUSTMENTS,
  GET_ALL_PRICE_ADJUSTMENTS_SUCCESS,
  SET_LOADING
} from 'store/platformPriceAdjustments/action';
import {FETCH_MENU_DATA} from 'store/menuEditor/action';
import {
  mapPlatformNameToBackend,
  mapPlatformNameFromBackend
} from 'helpers/functionUtils/menuPriceAdjusment';

function* getAllPriceAdjustments() {
  try {
    const {data} = yield call(getAllPriceAdjustmentsApi);
    if (data) {
      // Map platform names from backend format to UI format
      const mappedData = (data || []).map((adjustment) => ({
        ...adjustment,
        ProviderName: mapPlatformNameFromBackend(adjustment.ProviderName)
      }));
      yield put(GET_ALL_PRICE_ADJUSTMENTS_SUCCESS(mappedData));
    }
  } catch (error) {
    yield put(SET_LOADING(false));
    console.error('SAGA [getAllPriceAdjustments] ERROR', error);
  }
}

function* createPriceAdjustment({payload: {payload, successCallback}}) {
  try {
    // Map platform name from UI format to backend format
    const mappedPayload = {
      ...payload,
      ProviderName: mapPlatformNameToBackend(payload.ProviderName)
    };
    const {data} = yield call(createPriceAdjustmentApi, mappedPayload);
    if (data) {
      // Map platform name from backend format to UI format
      const mappedData = {
        ...data,
        ProviderName: mapPlatformNameFromBackend(data.ProviderName)
      };
      yield put(CREATE_PRICE_ADJUSTMENT_SUCCESS(mappedData));
      toast.success('Price adjustment rule applied');
      yield put(FETCH_MENU_DATA());
      if (successCallback) successCallback();
    }
  } catch (error) {
    yield put(SET_LOADING(false));
    console.error('SAGA [createPriceAdjustment] ERROR', error);
  }
}

function* deletePriceAdjustment({payload: {id, successCallback}}) {
  try {
    const response = yield call(deletePriceAdjustmentApi, id);
    if (response?.status === 200) {
      yield put(DELETE_PRICE_ADJUSTMENT_SUCCESS(id));
      toast.success('Price adjustment removed');
      yield put(FETCH_MENU_DATA());
      if (successCallback) successCallback();
    }
  } catch (error) {
    yield put(SET_LOADING(false));
    console.error('SAGA [deletePriceAdjustment] ERROR', error);
  }
}

function* resetAllPriceAdjustments({payload: {successCallback}}) {
  try {
    const request = yield call(resetAllPriceAdjustmentsApi);
    if (request?.status === 200) {
      yield put(RESET_ALL_PRICE_ADJUSTMENTS_SUCCESS());
      toast.success('All price adjustments reset to base prices');
      yield put(FETCH_MENU_DATA());
      if (successCallback) successCallback();
    }
  } catch (error) {
    yield put(SET_LOADING(false));
    console.error('SAGA [resetAllPriceAdjustments] ERROR', error);
  }
}

export default function* platformPriceAdjustmentsSaga() {
  yield takeEvery(GET_ALL_PRICE_ADJUSTMENTS, getAllPriceAdjustments);
  yield takeEvery(CREATE_PRICE_ADJUSTMENT, createPriceAdjustment);
  yield takeEvery(DELETE_PRICE_ADJUSTMENT, deletePriceAdjustment);
  yield takeEvery(RESET_ALL_PRICE_ADJUSTMENTS, resetAllPriceAdjustments);
}
